import React, { FC } from 'react';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { useEnvironment, useExperiments, WidgetProps } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import { noModal, ModalType, GenericModal } from '../../../types/common';
import { AlertModal } from '../../PackagePicker/Widget/AlertModal';
import List, { ListWidgetProps } from '../../PackagePicker/Widget/List';
import { EmptyStateProps } from '../../PackagePicker/Widget/List/EmptyState';
import { PlanListWidgetContext } from './PlanListWidgetContext';

const LazyListV2 = loadable(() => import('../../PackagePicker/Widget/ListV2'));

export interface ListWidgetWithModalProps extends ListWidgetProps {
  modal: GenericModal<ModalType.PurchaseInPreview> | typeof noModal;
}

const Widget: FC<WidgetProps<ListWidgetWithModalProps>> = (props) => {
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const emptyState: EmptyStateProps = { isInWidget: true, subtitle: props.plansErrorMessage };
  const width = props.host.dimensions.width ?? (isMobile ? 320 : 980);

  return (
    <PlanListWidgetContext locale={props.locale} width={width}>
      {experiments.enabled(TPA_EXPERIMENTS.PLAN_LIST_V2) ? (
        <LazyListV2 {...props} dataHook="PlanList-wrapper" emptyState={emptyState} />
      ) : (
        <List {...props} dataHook="PlanList-wrapper" emptyState={emptyState} />
      )}
      {props.modal.type === ModalType.PurchaseInPreview && <AlertModal {...props.modal} />}
    </PlanListWidgetContext>
  );
};

export default Widget;
